export default __webpack_public_path__ + "static/media/closet5-after2-2048w.8b6e8a61.avif";